import { render, staticRenderFns } from "./AddSerialModel.vue?vue&type=template&id=08aefa49&"
import script from "./AddSerialModel.vue?vue&type=script&lang=js&"
export * from "./AddSerialModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports